export default "__VITE_ASSET__DqJk3JlM__"